import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function ElementusHero() {
  const eyebrowRef = useRef(null);
  const word1Ref = useRef(null);
  const word2Ref = useRef(null);
  const tagRef = useRef(null);
  const descRef = useRef(null);
  const ctaRef = useRef(null);
  const statsRef = useRef(null);
  const headingRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.set(descRef.current, { opacity: 0, y: 30 });
      gsap.set(ctaRef.current, { opacity: 0, y: 20 });
      gsap.set([word1Ref.current, word2Ref.current], { y: "110%" });

      const tl = gsap.timeline({ defaults: { ease: "power4.out" } });

      tl.to(eyebrowRef.current, { opacity: 1, y: 0, duration: 0.8 }, 0.2)
        .to(word1Ref.current, { y: "0%", duration: 1.1 }, 0.4)
        .to(word2Ref.current, { y: "0%", duration: 1.1 }, 0.55)
        .to(tagRef.current, { opacity: 1, y: 0, duration: 0.6 }, 1.0)
        .to(descRef.current, { opacity: 1, y: 0, duration: 0.9 }, 0.7)
        .to(ctaRef.current, { opacity: 1, y: 0, duration: 0.8 }, 1.0)
        .to(statsRef.current, { opacity: 1, y: 0, duration: 0.8 }, 1.2);

      gsap.to(headingRef.current, {
        y: -8,
        duration: 4,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1,
        delay: 2,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <section
      className="
      relative
      md:min-h-screen
      grid
      grid-cols-1 min-h-[90vh] md:grid-cols-2
      items-center
      gap-10 md:gap-0
      px-[30px] md:px-10
      py-16 md:py-0
      max-w-[1400px]
      mx-auto
      overflow-hidden
      "
    >
      {/* LEFT */}
      <div className="relative z-10">

        <h1
          ref={headingRef}
          className="
          font-bold
          text-[#12132b]
          leading-[1]
          text-[42px]
          sm:text-[56px]
          md:text-[72px]
          lg:text-[90px]
          "
        >
          <span className="block overflow-hidden">
            <span ref={word1Ref} className="inline-block">
              Element Us Labs
            </span>
          </span>

          <span className="block overflow-hidden">
            <span ref={word2Ref} className="inline-block">
              in the News
            </span>
          </span>
        </h1>

      </div>

      {/* RIGHT */}
      <div
        className="
        relative
        z-10
        md:pl-[5vw]
        "
      >
        <p
          ref={descRef}
          className="
          font-light
          text-[#8932f6]
          leading-snug
          text-[20px]
          sm:text-[24px]
          md:text-[28px]
          lg:text-[34px]
          max-w-[520px]
          "
        >
          Explore media coverage, articles, announcements and press releases
          related to Element Us Labs and our role in shaping the world of web3.
        </p>
      </div>
    </section>
  );
}